import {
  AfterContentInit,
  Component,
  ContentChild,
  ContentChildren,
  OnInit,
  QueryList,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { NzTimelineItemComponent } from './nz-timeline-item.component';

@Component({
  selector     : 'nz-timeline',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <ul class="ant-timeline" [class.ant-timeline-pending]="_isPending">
      <ng-content></ng-content>
      <li *ngIf="_isPending" class="ant-timeline-item ant-timeline-item-pending">
        <div class="ant-timeline-item-tail"></div>
        <div class="ant-timeline-item-head ant-timeline-item-head-blue"></div>
        <div class="ant-timeline-item-content">
          <ng-template [ngTemplateOutlet]="_pendingContent">
          </ng-template>
        </div>
      </li>
    </ul>`,
  styles: [ `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}
.ant-timeline-item {
  position: relative;
  padding: 0 0 12px;
  list-style: none;
  margin: 0;
}
.ant-timeline-item-tail {
  position: absolute;
  left: 5px;
  top: 0;
  height: 100%;
  border-left: 2px solid #e9e9e9;
}
.ant-timeline-item-pending .ant-timeline-item-tail {
  display: none;
}
.ant-timeline-item-head {
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: #fff;
  border-radius: 100px;
  border: 2px solid transparent;
}
.ant-timeline-item-head-blue {
  border-color: #108ee9;
  color: #108ee9;
}
.ant-timeline-item-head-red {
  border-color: #f04134;
  color: #f04134;
}
.ant-timeline-item-head-green {
  border-color: #00a854;
  color: #00a854;
}
.ant-timeline-item-head-custom {
  position: absolute;
  text-align: center;
  width: 40px;
  left: -14px;
  line-height: 1;
  margin-top: 6px;
  border: 0;
  height: auto;
  border-radius: 0;
  padding: 3px 0;
  font-size: 12px;
  transform: translateY(-50%);
}
.ant-timeline-item-content {
  padding: 0 0 10px 24px;
  font-size: 12px;
  position: relative;
  top: -3px;
}
.ant-timeline-item-last .ant-timeline-item-tail {
  border-left: 2px dotted #e9e9e9;
  display: none;
}
.ant-timeline-item-last .ant-timeline-item-content {
  min-height: 48px;
}
.ant-timeline.ant-timeline-pending .ant-timeline-item-last .ant-timeline-item-tail {
  display: block;
}
` ]
})
export class NzTimelineComponent implements OnInit, AfterContentInit {
  _isPending = false;
  items: NzTimelineItemComponent[] = [];
  @ContentChildren(NzTimelineItemComponent) _listOfTimeline: QueryList<NzTimelineItemComponent>;
  @ContentChild('pending') _pendingContent: TemplateRef<void>;

  ngOnInit(): void {
    if (this._pendingContent) {
      this._isPending = true;
    }
  }

  ngAfterContentInit(): void {
    setTimeout(_ => {
      if (this._listOfTimeline && this._listOfTimeline.length) {
        const listArray = this._listOfTimeline.toArray();
        listArray[ listArray.length - 1 ]._lastItem = true;
      }
    });
  }
}
